import _ = require('underscore');

import { Messages } from '../../../../codegen/Localize';
import { ISubscriptionInfo } from '../../../../ts/models/ISubscriptionInfo';
import { changeSubscriptionsSchedule } from '../../../actions/spaces/SubscriptionsActions';
import { IEntityAction } from './IEntityAction';

export const ChangeSubscriptionScheduleEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: 'tasks-change-schedule',
  translateName: Messages.changeSchedule_action,
  isVisible: () => true,
  isClickable: (availableActions: {}, subscriptions: ISubscriptionInfo[]) => {
    return _.any(subscriptions, (subscription) => subscription.canManageSubscription);
  },
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => changeSubscriptionsSchedule(subscriptions)
};
